<template>
  <div class="main-menu">
    <section
      v-for="section in items"
      :key="section.name"
    >
      <h6 v-if="section.name">{{ section.name }}</h6>
      <ul class="menu-section">
        <li
          v-for="item in section.items"
          :key="item.id"
        >
          <router-link
            :to="{name:item.route}"
            active-class="active"
          >
            {{ item.name }}
          </router-link>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MainMenu',
  props: {
    /**
       * Items a ser desplegados en el menu
       * {
     *  name:'SECTION NAME',
     *  items:[
     *    {
     *    name:'Item name',
     *    route:'Route name'
     *    }
     *  ]
     * }
       */
    items: {
      required: true,
      type: Array,
      default: () => {
        return []
      }
    }
  }
}
</script>

<style
  lang="scss"
  scoped
>
  .main-menu {
    overflow: auto;
    section {
      margin: 0 20px 0px 20px;
      padding: 20px 0;
      border-top: 1px solid #dddddd;
      h6 {
        @include font-primary(10px, bold);
        color: #c7c7c7;
        margin-bottom: 8px;
        cursor: default;
      }
      ul {
        margin: 0;
        padding: 0;
        li {
          display: block;
          margin: 7px 0;
          list-style: none;
          a {
            color: #444444;
            text-decoration: none;
            @include font-primary(11px, semibold);
            &:hover {
              text-decoration: none;
            }
            &.active {
              @include font-primary(11px, bold);
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/main-layout/main-menu.vue